module.exports = __webpack_public_path__ + "img/res_software.10ec3082.png";